// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__12u5t","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__1U9xE"};